import Ansar from "../../../assets/images/bankIcon/Ansar.png"
import Sepah from "../../../assets/images/bankIcon/Sepah_0.png"
import Ayandeh from "../../../assets/images/bankIcon/Ayandeh.png"
import Dey from "../../../assets/images/bankIcon/Dey.png"
import EghtesadNovin from "../../../assets/images/bankIcon/Eghtesad-novin.png"
import Kaspian from "../../../assets/images/bankIcon/Kaspian.png"
import Keshavarzi from "../../../assets/images/bankIcon/Keshavarzi.png"
import Ghavamin from "../../../assets/images/bankIcon/Ghavamin_0.png"
import markazi from "../../../assets/images/bankIcon/markazi.png"
import Maskan from "../../../assets/images/bankIcon/Maskan.png"
import Mehr from "../../../assets/images/bankIcon/Mehr_0.png"
import Mellat from "../../../assets/images/bankIcon/Mellat.png"
import Melli from "../../../assets/images/bankIcon/Melli.png"
import Parsian from "../../../assets/images/bankIcon/Parsian_0.png"
import Pasargad from "../../../assets/images/bankIcon/Pasargad.png"
import Refah from "../../../assets/images/bankIcon/Refah_1.png"
import Resalat from "../../../assets/images/bankIcon/Resalat.png"
import Saderat from "../../../assets/images/bankIcon/Saderat_0.png"
import Saman from "../../../assets/images/bankIcon/Saman.png"
import sarmayeh from "../../../assets/images/bankIcon/sarmayeh_0.png"
import shahr from "../../../assets/images/bankIcon/shahr_0.png"
import Tejarat from "../../../assets/images/bankIcon/Tejarat_0.png"
import toseh from "../../../assets/images/bankIcon/toseh.png"
import TosehTavon from "../../../assets/images/bankIcon/Toseh-tavon.png"

const bankArray = [
    {
        id:101,
        name:"انصار",
        imgPath:Ansar
      },
      
      {
        id:102,
        name:"آینده",
        imgPath:Ayandeh
      },
      {
        id:103,
        name:"دی",
        imgPath:Dey
      },
      {
        id:104,
        name:"اقتصاد نوین",
        imgPath:EghtesadNovin
      },
      {
        id:105,
        name:"کاسپین",
        imgPath:Kaspian
      },
      {
        id:106,
        name:"مرکزی",
        imgPath:markazi
      },
      {
        id:107,
        name:"مهر",
        imgPath:Mehr
      },
    {
        id:108,
        name:"ملت",
        imgPath:Mellat
      },
      {
        id:109,
        name:"صادرات",
        imgPath:Saderat
      },
      {
        id:110,
        name:"مسکن",
        imgPath:Maskan
      },
      {
        id:111,
        name:"پارسیان",
        imgPath:Parsian
      },
      {
        id:112,
        name:"ملی",
        imgPath:Melli
      },
      {
        id:113,
        name:"رفاه",
        imgPath:Refah
      },
    {
      id:114,
      name:"سرمایه",
      imgPath:sarmayeh
    },
    {
        id:115,
        name:"توسعه",
        imgPath:toseh
      },
    {
      id:116,
      name:"سامان",
      imgPath:Saman
    },
    {
        id:117,
        name:"کشاورزی",
        imgPath:Keshavarzi
      },
     
      {
        id:118,
        name:"قوامین",
        imgPath:Ghavamin
      },
      
      {
        id:119,
        name:"رسالت",
        imgPath:Resalat
      },
      {
        id:120,
        name:"شهر",
        imgPath:shahr
      },
      {
        id:121,
        name:"پاسارگاد",
        imgPath:Pasargad
      },
      {
        id:122,
        name:"تجارت",
        imgPath:Tejarat
      },
      {
        id:123,
        name:"توسعه و تعاون",
        imgPath:TosehTavon
      },
      {
        id:124,
        name:"سپه",
        imgPath:Sepah
      },
      
  ];

  export default bankArray;